import { FC } from "react";
import { useNavigate } from "react-router-dom";
import { 
  Box, 
  Typography, 
  Button, 
  Container,
  Stack,
  Fade
} from "@mui/material";
import { Home, CardGiftcard, Explore } from "@mui/icons-material";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer/Footer";
import hero1 from "../../assets/public/hero/desktop1.jpg";

const NotFound: FC = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/');
  };

  const handleFindListings = () => {
    navigate('/listings');
  };

  const handleJoinRewards = () => {
 
    navigate('/romingo-rewards');
  };

  return (
    <>
      <Navbar />
      <Box
        component="main"
        role="main"
        sx={{
          minHeight: 'calc(100vh - 160px)', 
          backgroundImage: `url(${hero1})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.65)',
            zIndex: 1,
          }
        }}
      >
        <Container 
          maxWidth="lg" 
          sx={{ 
            position: 'relative', 
            zIndex: 2,
            py: { xs: 4, md: 8 }
          }}
        >
          <Fade in={true} timeout={800}>
            <Box>
              <Box
                sx={{
                  maxWidth: { xs: '100%', md: '800px', lg: '900px' },
                  minHeight: '760px',
                  color: 'white',
                }}
              >
              
                <Typography
                  variant="h1"
                  component="h1"
                  sx={{
                    fontSize: { xs: '3rem', md: '5rem', lg: '6rem' },
                    fontWeight: 'bold',
                    color: 'white',
                    mb: 2,
                    lineHeight: 1,
                    textShadow: '3px 3px 6px rgba(0, 0, 0, 0.8)',
                    letterSpacing: '-0.02em',
                  }}
                >
                  Oops!
                </Typography>
                
                {/* Main message */}
                <Typography
                  variant="h2"
                  component="h2"
                  sx={{
                    fontSize: { xs: '2rem', md: '3.5rem', lg: '4rem' },
                    fontWeight: 'bold',
                    color: 'white',
                    mb: 4,
                    lineHeight: 1.1,
                    textShadow: '2px 2px 4px rgba(0, 0, 0, 0.8)',
                    letterSpacing: '-0.01em',
                  }}
                >
                  It seems you and your pup have wandered off the path.
                </Typography>

                {/* Subtitle */}
                <Typography
                  variant="body1"
                  sx={{
                    color: 'white',
                    mb: 5,
                    fontSize: { xs: '1.2rem', md: '1.4rem' },
                    fontWeight: 400,
                    textShadow: '1px 1px 3px rgba(0, 0, 0, 0.8)',
                    lineHeight: 1.5,
                    maxWidth: '600px',
                  }}
                >
                  Let&apos;s get your tail-wagging adventure back on track with one of these pawsome options:
                </Typography>

                {/* Enhanced Action Buttons */}
                <Stack
                  direction="column"
                  spacing={3}
                  alignItems="flex-start"
                  sx={{ mt: 4 }}
                >
                  <Button
                    variant="contained"
                    onClick={handleGoHome}
                    startIcon={<Home />}
                    sx={{
                      backgroundColor: 'rgba(255, 255, 255, 0.15)',
                      color: 'white',
                      fontSize: { xs: '1.1rem', md: '1.2rem' },
                      py: 1.5,
                      px: 3,
                      borderRadius: 2,
                      textTransform: 'none',
                      fontWeight: 500,
                      border: '1px solid rgba(255, 255, 255, 0.3)',
                      boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        backgroundColor: 'rgba(3, 152, 158, 0.3)',
                        transform: 'translateY(-2px)',
                        boxShadow: '0 12px 40px rgba(3, 152, 158, 0.4)',
                        border: '1px solid rgba(3, 152, 158, 0.5)',
                      },
                      '&:focus': {
                        outline: '2px solid #03989E',
                        outlineOffset: '2px',
                      }
                    }}
                  >
                    Find pet-friendly stays
                  </Button>

                  <Button
                    variant="contained"
                    onClick={handleJoinRewards}
                    startIcon={<CardGiftcard />}
                    sx={{
                      backgroundColor: 'rgba(255, 255, 255, 0.15)',
                      color: 'white',
                      fontSize: { xs: '1.1rem', md: '1.2rem' },
                      py: 1.5,
                      px: 3,
                      borderRadius: 2,
                      textTransform: 'none',
                      fontWeight: 500,
                      border: '1px solid rgba(255, 255, 255, 0.3)',
                      boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        backgroundColor: 'rgba(3, 152, 158, 0.3)',
                        transform: 'translateY(-2px)',
                        boxShadow: '0 12px 40px rgba(3, 152, 158, 0.4)',
                        border: '1px solid rgba(3, 152, 158, 0.5)',
                      },
                      '&:focus': {
                        outline: '2px solid #03989E',
                        outlineOffset: '2px',
                      }
                    }}
                  >
                    Join Romingo Rewards 🐶
                  </Button>
 
                </Stack>
              </Box>
            </Box>
          </Fade>
        </Container>
      </Box>
      <Footer />
    </>
  );
};

export default NotFound;
